
<template>
  <div class="nf-box">
    <!--header start-->
    <div class="header detail-header">
      <a href="javascript:void(0);" class="f-l">
        <router-link to="/home" tag="i" class="icon-logo"></router-link>
        <!-- <span>上电视</span>-->
      </a>
      <span>
        <img :src="globalUrl + 'static/dist/img/sds.png'" alt=""/>
      </span>
      <a href="javascript:void(0)" class="f-r">
        <router-link to="/find" tag="i" class="icon-menu"></router-link>
      </a>
    </div>
    <!--header end-->
    <div class="content">
      <div class="img-box">
        <img :src="globalUrl + 'static/dist/img/xx.png'" alt="">
      </div>
        <p class="nf-word">呀，活动找不到了！</p>
    </div>

  </div>
</template>
<script>
 export default {
        data ()
    {
        return {
          globalUrl : API.GlobalUrl
        }
    }
    ,
    methods: {
        //操作按钮事件
    }
    ,
    mounted: function () {
        //操作DOM
    }

  }
</script>

<style scoped>
  .nf-box{
    flex: 1;
    background: #f8f8f8;
    text-align: center;
  }
  .img-box{
    padding-left: 10%;
    padding-top: 150px;
  }
  .img-box img{
    width: auto;
    height: 100px;
  }
  .nf-word{
    margin-top: 40px;
    font-size: 18px;
    color: #999;
  }

</style>



// WEBPACK FOOTER //
// src/components/template/notFound.vue